import { render, staticRenderFns } from "./OtpCopier.vue?vue&type=template&id=37c1f8f8&"
import script from "./OtpCopier.vue?vue&type=script&lang=js&"
export * from "./OtpCopier.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports